export const GET_TASKS_BEGIN = 'GET_TASKS_BEGIN'
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS'
export const GET_TASKS_ERROR = 'GET_TASKS_ERROR'

export const DELETE_TASK_BEGIN = 'DELETE_TASK_BEGIN'
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS'
export const DELETE_TASK_ERROR = 'DELETE_TASK_ERROR'

export const CREATE_TASK_BEGIN = 'CREATE_TASK_BEGIN'
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS'
export const CREATE_TASK_ERROR = 'CREATE_TASK_ERROR'

export const UPDATE_TASK_BEGIN = 'UPDATE_TASK_BEGIN'
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS'
export const UPDATE_TASK_ERROR = 'UPDATE_TASK_ERROR'

export const ADD_TASK_POSITION_BEGIN = 'ADD_TASK_POSITION_BEGIN'
export const ADD_TASK_POSITION_SUCCESS = 'ADD_TASK_POSITION_SUCCESS'
export const ADD_TASK_POSITION_ERROR = 'ADD_TASK_POSITION_ERROR'

export const DELETE_TASK_POSITION_BEGIN = 'DELETE_TASK_POSITION_BEGIN'
export const DELETE_TASK_POSITION_SUCCESS = 'DELETE_TASK_POSITION_SUCCESS'
export const DELETE_TASK_POSITION_ERROR = 'DELETE_TASK_POSITION_ERROR'

export const ADD_TASK_EXEMPTION_BEGIN = 'ADD_TASK_EXEMPTION_BEGIN'
export const ADD_TASK_EXEMPTION_SUCCESS = 'ADD_TASK_EXEMPTION_SUCCESS'
export const ADD_TASK_EXEMPTION_ERROR = 'ADD_TASK_EXEMPTION_ERROR'

export const DELETE_TASK_EXEMPTION_BEGIN = 'DELETE_TASK_EXEMPTION_BEGIN'
export const DELETE_TASK_EXEMPTION_SUCCESS = 'DELETE_TASK_EXEMPTION_SUCCESS'
export const DELETE_TASK_EXEMPTION_ERROR = 'DELETE_TASK_EXEMPTION_ERROR'

export const ADD_TASK_SKILL_BEGIN = 'ADD_TASK_SKILL_BEGIN'
export const ADD_TASK_SKILL_SUCCESS = 'ADD_TASK_SKILL_SUCCESS'
export const ADD_TASK_SKILL_ERROR = 'ADD_TASK_SKILL_ERROR'

export const DELETE_TASK_SKILL_BEGIN = 'DELETE_TASK_SKILL_BEGIN'
export const DELETE_TASK_SKILL_SUCCESS = 'DELETE_TASK_SKILL_SUCCESS'
export const DELETE_TASK_SKILL_ERROR = 'DELETE_TASK_SKILL_ERROR'